"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _axios = _interopRequireDefault(require("axios"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import clipboard from '@/directive/clipboard/index.js' // use clipboard by v-directive
// import clip from '@/utils/clipboard' // use clipboard directly
var _default = exports.default = {
  name: 'Sysconfig',
  // directives: {
  //   clipboard
  // },
  data: function data() {
    var _this = this;
    var validateConfigType = function validateConfigType(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('sysconfig.error.configType')));
      } else if (_this.errorKeys.indexOf('configType') >= 0) {
        callback(new Error(_this.errorInfo['configType']));
        _this.resetError('configType');
      } else {
        callback();
      }
    };
    var validateConfigCode = function validateConfigCode(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('sysconfig.error.configCode')));
      } else if (_this.errorKeys.indexOf('configCode') >= 0) {
        callback(new Error(_this.errorInfo['configCode']));
        _this.resetError('configCode');
      } else {
        callback();
      }
    };
    var validateSn = function validateSn(rule, value, callback) {
      value = Number(value);
      if (typeof value === 'number' && !isNaN(value)) {
        callback();
      } else {
        callback(new Error(_this.$t('sysconfig.error.sn')));
      }
    };
    return {
      pageName: 'sysconfig',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        type: '',
        code: ''
      },
      dialogStatus: 'create',
      form: {
        systemConfigPk: '',
        configType: '',
        configCode: '',
        configVal: '',
        sn: '',
        remark: ''
      },
      initForm: {
        systemConfigPk: '',
        configType: '',
        configCode: '',
        configVal: '',
        sn: '',
        remark: ''
      },
      rules: {
        configType: [{
          required: true,
          trigger: ['change'],
          validator: validateConfigType
        }],
        configCode: [{
          required: true,
          trigger: ['change'],
          validator: validateConfigCode
        }],
        configVal: [{
          required: true,
          trigger: ['change'],
          message: this.$t('sysconfig.error.configVal')
        }],
        sn: [{
          required: false,
          trigger: ['change'],
          validator: validateSn
        }]
      },
      errorKeys: [],
      errorInfo: {}
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          configType: this.searchVal.type,
          configCode: this.searchVal.code
        }
      };
      this.listLoading = true;
      this.$api.sysconfig.getSysConfigList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    create: function create() {
      var _this3 = this;
      this.dialogStatus = 'create';
      this.form = {
        systemConfigPk: '',
        configType: '',
        configCode: '',
        configVal: '',
        sn: '',
        remark: ''
      };
      this.initForm = {
        systemConfigPk: '',
        configType: '',
        configCode: '',
        configVal: '',
        sn: '',
        remark: ''
      };
      this.isShowModel = true;
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    edit: function edit(row) {
      var _this4 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.systemConfigPk;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this4.isShowModel = true;
        _this4.$nextTick(function () {
          _this4.$refs['dataForm'].clearValidate();
        });
      });
    },
    getDetail: function getDetail() {
      var _this5 = this;
      return new Promise(function (resolve) {
        _this5.isLoading = true;
        _this5.$api.sysconfig.getSysConfigDetail(_this5.currentId).then(function (res) {
          _this5.isLoading = false;
          var _res$data = res.data,
            systemConfigPk = _res$data.systemConfigPk,
            configType = _res$data.configType,
            configCode = _res$data.configCode,
            configVal = _res$data.configVal,
            sn = _res$data.sn,
            remark = _res$data.remark;
          _this5.form = {
            systemConfigPk: systemConfigPk,
            configType: configType,
            configCode: configCode,
            configVal: configVal,
            sn: sn,
            remark: remark
          };
          _this5.initForm = {
            systemConfigPk: systemConfigPk,
            configType: configType,
            configCode: configCode,
            configVal: configVal,
            sn: sn,
            remark: remark
          };
          resolve(_this5.form);
        }).catch(function () {
          console.log('Data Request Fail');
          _this5.isLoading = false;
        });
      });
    },
    deleteItem: function deleteItem(row) {
      var _this6 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this6.isLoading = true;
        _this6.$api.sysconfig.deleteSysConfig([row.systemConfigPk]).then(function (res) {
          _this6.isLoading = false;
          _this6.refreshData();
        }).catch(function () {
          _this6.isLoading = false;
        });
      }).catch(function () {});
    },
    saveItem: function saveItem() {
      var _this7 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this7.isLoading = true;
        _this7.$api.sysconfig.saveSysConfig(_this7.form).then(function (res) {
          _this7.isLoading = false;
          _this7.isShowModel = false;
          _this7.refreshData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this7.resetError();
            err.errorInfos.forEach(function (item) {
              _this7.errorKeys.push(item.key);
              _this7.errorInfo[item.key] = item.errMsg;
            });
            _this7.$refs['dataForm'].validate();
          }
          _this7.isLoading = false;
        });
      });
    },
    celldblclick: function celldblclick(row, column, cell, event) {
      // const _this = this
      // clip(event.target.innerText, event)
    }
  }
};